import { render } from "./Performance.vue?vue&type=template&id=d8e9ad24&scoped=true"
import script from "./Performance.vue?vue&type=script&lang=js"
export * from "./Performance.vue?vue&type=script&lang=js"

import "./Performance.vue?vue&type=style&index=0&id=d8e9ad24&lang=scss&scoped=true"

import exportComponent from "/Applications/CODE/mickwebsite/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8e9ad24"]])

export default __exports__